"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NutrientFunction_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/report/NutrientFunction"));
class ReportNutrientFunction {
    constructor() {
        this.rank = null;
        this.nutrientFunction = new NutrientFunction_1.default();
    }
    static fromRaw(rawNutrient, rawFunc) {
        const rnf = new ReportNutrientFunction();
        rnf.rank = rawFunc.pivot.rank;
        rnf.nutrientFunction = NutrientFunction_1.default.fromRaw(rawNutrient, rawFunc);
        return rnf;
    }
}
exports.default = ReportNutrientFunction;
